module.exports = __webpack_public_path__ + "img/35.6.CODm.d72b7d9d.png";